import { polyfill, trustPolicies } from './assets/TrustedTypes.js';
const polyfilled = polyfill();
export { trustPolicies, polyfilled };
